import styled, {css} from "styled-components";
import {JACKPOT_WIDGET_LAYOUT} from "../../../jackpot-widget/jackpot-widget.component";
import {IJackpotBetWidgetBgBoxProps} from "./jackpot-bet-widget-bg.box";
import {baseColors} from "../../../../themes/definitions/casino777/base-colors";

export const JackpotBetWidgetBg777Box = styled.div<IJackpotBetWidgetBgBoxProps>`
  height: 35rem;

  box-shadow: 0px 8px 8px 1px #00000038, 0px -1px 24px 8px #49968D80 inset;
  
  border-radius: 10px;


  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE && css`
        flex-direction: row;
        align-items: center;
    `}

  background-image: url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_mountains_bg_png.toString()}),
  linear-gradient(168.55deg, #8CD1BA 23.09%, ${baseColors.base02} 56.92%);
  
  background-blend-mode: darken;
  background-size: 190%;
  background-repeat: no-repeat, no-repeat;
  background-position-y: 140%;
  background-position-x: 43%;

  @media ${({theme}) => theme.mediaQuery.xs} {
    background-size: 230%;
  }

    @media ${({theme}) => theme.mediaQuery.sExact} {
        background-position-y: 130%;
    }

  @media ${({theme}) => theme.mediaQuery.mAndAbove + " and " + theme.mediaQuery.portrait} {
    background-size: 230%;
  }

    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {            
        background-size: 180%;
        background-position-y: 100%;
    }
`;
